// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-5775e230]{fill:var(--v-primary-base);stroke:#fff;stroke-width:2px}", ""]);
// Exports
module.exports = exports;
